module.exports = __webpack_public_path__ + "static/media/carousel_1.33337431.jpg";